package com.milta.core.localization.translations.pl

import com.milta.core.localization.WebImportRouteStrings

internal val WebImportRoute = WebImportRouteStrings(
    headerSubtitle = "Prześlij plik dostaw i przypisz go do kierowcy",
    stepImport = "Importuj",
    stepVerifyAssign = "Sprawdź i przypisz",
    stepValidateSend = "Zatwierdź i wyślij trasy",
    dropzoneTitle = "Przeciągnij i upuść plik z dostawami",
    dropzoneOrPrefix = "lub",
    browseFilesLink = "przeglądaj swoje pliki",
    browseFilesButton = "Przeglądaj pliki",
    constraintsLabel = "Excel (.xlsx, .xls) lub CSV · maks. 500 przystanków · 10 MB",
    expectedColumnsEyebrow = "Oczekiwane kolumny w pliku",
    columnRecipientName = "Imię i nazwisko odbiorcy",
    columnAddress = "Pełny adres",
    columnDeadline = "Godzina graniczna",
    columnPhone = "Telefon",
    requiredPillLabel = "Wymagane",
    optionalPillLabel = "Opcjonalne",
    analysingLabel = "Analizowanie…",
    invalidFileTitle = "Nieczytelny plik lub nieobsługiwany format",
    invalidFileMessage = "„%s” nie mógł zostać przeanalizowany. Użyj pliku Excel (.xlsx, .xls) lub CSV zgodnego z oczekiwanymi kolumnami.",
    chooseAnotherFileButton = "Wybierz inny plik",
    extractionFailedTitle = "Nie można wyodrębnić dostaw",
    extractionFailedMessage = "Plik „%s” został odczytany, ale nie znaleziono żadnego użytecznego wiersza. Sprawdź, czy zawiera oczekiwane kolumny.",
    serviceUnavailableTitle = "Usługa analizy tymczasowo niedostępna",
    serviceUnavailableMessage = "Nie możemy teraz przeanalizować Twojego pliku. Spróbuj ponownie za chwilę.",
    retryButton = "Spróbuj ponownie",
    fileImportedStatus = "Plik zaimportowany",
    stopsDetectedSuffix = "wykrytych przystanków",
    replaceFileLink = "↺ Zastąp",
    assignToEyebrow = "Przypisz do",
    selectDriverRequiredError = "Wybierz przynajmniej jednego kierowcę przed wysłaniem trasy.",
    selectedDriversCountSuffix = "wybranych kierowców",
    optimizeRouteButton = "Optymalizuj trasę",
    tableCaptionLead = "Sprawdź i popraw przystanki przed wysłaniem",
    tableCaptionHint = "Kliknij ikonę ołówka, aby poprawić wiersz",
    columnHeaderIndex = "#",
    columnHeaderRecipientName = "Imię i nazwisko odbiorcy",
    columnHeaderAddress = "Adres",
    columnHeaderPhone = "Telefon",
    columnHeaderDeadline = "Godzina graniczna",
    dashPlaceholder = "—",
    freeFormatBanner = "Wykryto format dowolny — kolumny nie mogły zostać rozpoznane automatycznie, sprawdź każdy wiersz przed wysłaniem.",
    incompleteStopsBannerSuffix = "niekompletnych przystanków — brak imienia lub adresu, do poprawienia przed wysłaniem.",
    rowFlagMissingName = "⚠ brak imienia",
    rowFlagMissingAddress = "⚠ brak adresu",
    alreadyDispatchedBanner = "Ta trasa została już wysłana do kierowcy — odśwież stronę, aby rozpocząć nowy import.",
    routeNotFoundError = "Nie znaleziono trasy. Odśwież stronę i spróbuj ponownie.",
    validationErrorGeneric = "Sprawdź wprowadzone informacje.",
    submitServerError = "Wystąpił błąd. Spróbuj ponownie.",
    submitOptimizationUnavailableError = "Usługa optymalizacji tymczasowo niedostępna. Trasa nie została utworzona — spróbuj ponownie za chwilę.",
    sendWithoutOptimizationButton = "Wyślij bez optymalizacji",
    dispatchSuccessMessage = "Trasa została pomyślnie wysłana do %s",
    dispatchSuccessBatchMessage = "Trasy zostały pomyślnie wysłane do %d kierowców",
    tooManyStopsError = "Ten plik zawiera więcej niż 500 dostaw. Podziel go przed zaimportowaniem.",
    resultHeaderMiddle = "dostaw rozdzielonych między",
    resultDriverSingularSuffix = "kierowcę",
    resultDriverPluralSuffix = "kierowców",
    resultDistanceLabel = "Odległość",
    resultDurationLabel = "Szacowany czas",
    resultMetricNotCalculatedLabel = "Nieobliczona",
    resultStopsChipSuffix = "przystanków",
    resultMoreStopsTemplate = "+ %d innych przystanków",
    resultStopsLoadError = "Nie udało się wczytać przystanków tej trasy.",
    resultDispatchButton = "Zatwierdź i wyślij trasy",
)
